import { render, staticRenderFns } from "./ErrosBoxComponent.vue?vue&type=template&id=148439b2"
import script from "./ErrosBoxComponent.vue?vue&type=script&lang=js"
export * from "./ErrosBoxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports